import { atom } from 'recoil';
import BeaconFilterItem from '../models/BeaconFilterItem';

const stateEnodProjects = atom({
    key: 'beacon.enodProjects',
    default: [] as BeaconFilterItem[]
});


export default stateEnodProjects;
